import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ClickOutsideModule } from 'ng-click-outside';
import {
    MatDialogModule, MatButtonModule, MatSelectModule, MatRadioModule,
    MatFormFieldModule, MatInputModule, MatCheckboxModule, MatDatepickerModule,
    MatNativeDateModule, MAT_DATE_FORMATS, DateAdapter, MatCardModule,
    MatTooltipModule, MatMenuModule, MatProgressBarModule, MatIconModule,
    MatSnackBarModule, MatDividerModule
} from '@angular/material';

import { NgxMaskModule } from 'ngx-mask';

import * as Control from './controls/index';
import * as Directives from './directives/index';

import { pipe } from 'rxjs';

const MODULES = [
    NgxMaskModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatTooltipModule,
    MatMenuModule,
    MatProgressBarModule,
    MatIconModule,
    MatSnackBarModule,
    ClickOutsideModule,
    MatDividerModule
]

const CONTROLS = [
    Control.MessageControl,
    Control.ButtonControl,
    Control.LoadingControl,
]

const DIRECTIVES = [
    Directives.AutofocusDirective,
    Directives.DisablecopyDirective,
    Directives.DisableCutDirective,
    Directives.DisablepasteDirective,
    Directives.DisableEnterDirective
]
// Shared Module Screen Declarations and Exports

@NgModule({
    imports: [
        ...MODULES
    ],
    declarations: [
        ...CONTROLS,
    ],
    exports: [
        ...CONTROLS,
    ],
    providers: []
})
export class SharedModule { }


// WEBPACK FOOTER //
// ./SignClient/app/shared/shared.module.ts